import script from "./AboutSecondComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSecondComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutSecondComponent.vue?vue&type=style&index=0&id=3b89260e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b89260e"]])

export default __exports__